module.exports = __webpack_public_path__ + "img/banner1.862a3e0f.png";